export default {
    startPageLinks: false,
    startPage: false,
    loginWithoutRegister: false,
    logo: {
        isEnabled: true,
        locales: {
            ru: {
                src: require(`../resources/images/header_logo.svg`),
                alt: 'POF',
            },
        },
        style: { maxHeight: 60 },
        withText: false,
        mdLogo: false,
    },
    customBackground: {
        isEnabled: true,
    },
    helpIcon: false,
    notificationIcon: false,
    phoneNumber: true,
    startPageDefaultText: false,
    esiaLogin: false,
    showCreateRequestButton: false,
    showRequestsLamp: false,
    showCampaignPeriod: true,
    loginDialogClose: false,
    loginDialogAlert: true,
    yaMetrika: true,
    modularNavigation: false,
    email: true,
    changeLanguage: true,
};
